<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<path d="M14 5.9359C14 4.10185 12.55 2.6665 10.7 2.6665C9.66 2.6665 8.65 3.14495 8 3.91246C7.35 3.14495 6.34 2.6665 5.3 2.6665C3.45 2.6665 2 4.10185 2 5.9359C2 8.18859 4.04 10.0226 7.13 12.8036L7.51 13.1425C7.79 13.3917 8.22 13.4017 8.5 13.1425L8.87 12.8036C11.96 10.0226 14 8.18859 14 5.9359Z" />
</svg>
